import { UIHeading5 } from '@cian/ui-kit';
import { IconMapRoute16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { clsx } from 'clsx';
import * as style from './style.css';

interface IRouteButtonProps {
  fixed: boolean;
  onClick: () => void;
}

export const RouteButton: React.FC<IRouteButtonProps> = ({ fixed, onClick }) => {
  return (
    <div className={clsx(style['wrapper'], fixed ? style['fixed'] : style['normal'])}>
      <button className={style['button']} onClick={onClick}>
        <IconMapRoute16 color="icon-main-default" />
        <UIHeading5 color="text-primary-default">Построить маршрут</UIHeading5>
      </button>
    </div>
  );
};
